module.exports = __webpack_public_path__ + "media/customizations/valenciasky/logo-c4264c70791d0d7dcb31e38c5654688b.png";